import type { TAdornment } from '../../../../packages/Tags/shared/types/tag';

import { UndergroundIcon } from '../adornments';

// Не используем мапу, т.к. descriminated union плохо работает в объектах, типизировать пропсы сложно
export const getTagIcon = (adornment: TAdornment | undefined) => {
  if (!adornment) {
    return null;
  }

  switch (adornment.type) {
    case 'undergroundIcon':
      return <UndergroundIcon {...adornment.props} />;

    // Расширять следует таким образом:
    // case 'newAdornmentType':
    // return <NewAdornmentComponent {...adornment.props} />;
    default:
      return null;
  }
};
